import React, { useRef, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { FcInfo } from "react-icons/fc";

interface TooltipProps {
	children: React.ReactNode;
	position?: "top" | "bottom" | "left" | "right";
}

const Tooltip: React.FC<TooltipProps> = ({ children, position = "top" }) => {
	const [visible, setVisible] = useState(false);
	const iconRef = useRef<HTMLDivElement>(null);
	const [coords, setCoords] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const positionOffset = 8;

	useEffect(() => {
		if (visible && iconRef.current) {
			const rect = iconRef.current.getBoundingClientRect();
			let top = 0;
			let left = 0;

			switch (position) {
				case "top":
					top = rect.top - positionOffset;
					left = rect.left + rect.width / 2;
					break;
				case "bottom":
					top = rect.bottom + positionOffset;
					left = rect.left + rect.width / 2;
					break;
				case "left":
					top = rect.top + rect.height / 2;
					left = rect.left - positionOffset;
					break;
				case "right":
					top = rect.top + rect.height / 2;
					left = rect.right + positionOffset;
					break;
			}

			setCoords({ top, left });
		}
	}, [visible, position]);

	const tooltipElement = visible
		? ReactDOM.createPortal(
			<div
				style={{
					position: "fixed",
					top: coords.top,
					left: coords.left,
					transform:
						position === "top" || position === "bottom"
							? "translateX(-50%)"
							: "translateY(-50%)",
					zIndex: 9999,
				}}
				className="bg-gray-800 text-white text-sm px-3 py-2 rounded shadow-lg pointer-events-none"
			>
				{children}
			</div>,
			document.body
		)
		: null;

	return (
		<div
			className="inline-block relative"
			onMouseEnter={() => setVisible(true)}
			onMouseLeave={() => setVisible(false)}
		>
			<div className="inline-block cursor-pointer" ref={iconRef}>
				<FcInfo />
			</div>
			{tooltipElement}
		</div>
	);
};

export default Tooltip;
